module.exports = __webpack_public_path__ + "assets/img/tx316_1.10acf8a0.jpg";